import { useEffect, useState } from "react";
import { useParams } from "@/components/hooks/use-params";
import { Button } from "@/components/ui";

import { RedeemGiftCardModal } from "@luce/customer-app";

/**
 * The hero's two buttons on phone web: Figma's 16px side padding, and never
 * narrower than their label, so on a phone too narrow for both they wrap onto
 * two rows (with `web:flex-wrap` on the row) instead of cutting a label off.
 */
export const HERO_BUTTON_CLASS = "web:px-4 web:min-w-max";

export const SectionRedeem = () => {
  const { redeem } = useParams<{ redeem: string }>();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof redeem === "string") setOpen(true);
  }, [redeem]);

  return (
    <>
      <Button
        size={"lg"}
        onClick={() => setOpen(true)}
        variant={"secondary"}
        color={"CTA2"}
        fullWidth="full"
        className={HERO_BUTTON_CLASS}
      >
        Redeem Gift Card
      </Button>
      <RedeemGiftCardModal
        open={open}
        onOpenChange={setOpen}
        initialCode={typeof redeem === "string" ? redeem : undefined}
      />
    </>
  );
};
